import request from './requester';

export const register = async (data) => {
    return await request('POST', '/api/auth/register', data)
};

export const login = async (data) => {
    return await request('POST', `/api/auth/login`, data)
};

export const getUserInfo = async () => {
    // TODO: Add try catch
    const response = await request('GET', '/api/auth/user', {});
    return response;
};
